import { useCallback } from 'react';

const useFormBuffer = (key) => {
  const read = () => {
    try {
      const raw = sessionStorage.getItem(`formBuffer_${key}`);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const write = useCallback((stage, payload) => {
    try {
      sessionStorage.setItem(`formBuffer_${key}`, JSON.stringify({ stage, payload }));
    } catch { }
  }, [key]);

  const clear = useCallback(() => {
    sessionStorage.removeItem(`formBuffer_${key}`);
  }, [key]);

  return { readBuffer: read, writeBuffer: write, clearBuffer: clear };
};

export default useFormBuffer;
